import { render } from "./ActiveTD.vue?vue&type=template&id=4dd38ae2"
import script from "./ActiveTD.vue?vue&type=script&lang=js"
export * from "./ActiveTD.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__